import React, { useContext } from 'react';

import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import { usePredictorStore } from '../../store/predictor/predictorStore';
import FormattedCurrency from '../FormattedCurrency/FormattedCurrency';
import { useTranslation } from 'react-i18next';
import reactStringReplace from 'react-string-replace';
import { Prize } from '../../interfaces/predictors';
import './PrizeText.scss';

const getPrizeText = (t: (str: string) => string, prize: Prize) => {
  return reactStringReplace(t('win-up-to'), '{{amount}}', (match, index) => (
    <div
      key={'prize-value-' + index}
      className={`prize prize-value ${prize?.prizeAmount.toString().length > 7 ? 'large' : ''}`}
    >
      <FormattedCurrency currency={prize?.prizeCurrencyCode} value={prize?.prizeAmount} />
    </div>
  ));
};
const PrizeText = () => {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const activePredictor = usePredictorStore((s) => s.activePredictor);
  const nextPredictor = usePredictorStore((s) => s.nextPredictor);

  const prizes = activePredictor?.prizes ?? nextPredictor?.prizes;

  const prize = prizes?.find((prize) => user.currency === prize.prizeCurrencyCode);
  if (!prize || !prize?.prizeCurrencyCode || prize?.prizeAmount === undefined) return null;

  return (
    <div className='prize-container'>
      <div className='prize-text'>{getPrizeText(t, prize)}</div>
    </div>
  );
};
export default PrizeText;
